import type { JSX } from 'react';
import { EditableTextDisplay } from './EditableTextDisplay';
import { EditableTextInput } from './EditableTextInput';
import type { EditableTextRootProps } from './EditableTextRoot';
import { EditableTextRoot } from './EditableTextRoot';
import { EditableTextLabel } from './EditableTextLabel';

export type EditableTextProps = Omit<EditableTextRootProps, 'children'> & {
  /**
   * Whether to visually hide the label.
   */
  hideLabel?: boolean;
};

/**
 * Used for inline editing of text.
 */
export const EditableText = ({ hideLabel = true, ...props }: EditableTextProps): JSX.Element => (
  <EditableTextRoot {...props}>
    <EditableTextLabel screenReaderOnly={hideLabel} />
    <EditableTextInput />
    <EditableTextDisplay asTrigger={true} />
  </EditableTextRoot>
);

EditableText.displayName = 'EditableText';
